import { Body } from "@components/Typography";
import { useStyles } from "./styles";
import { SegmentedControlProps } from "./types";

const COMPACT_OPTION_COUNT = 3;

export const SegmentedControl = ({
  options,
  selectedKey,
  onSelect,
  style,
}: SegmentedControlProps) => {
  const styles = useStyles();

  // Four options ("Bi-weekly" included) do not fit the onboarding card width at
  // the default label size.
  const compactLabel = options.length > COMPACT_OPTION_COUNT ? { fontSize: 12 } : {};

  return (
    <div style={{ ...styles.container, ...style }}>
      {options.map(({ key, label }) => {
        const selected = key === selectedKey;

        return (
          <div
            key={key}
            onClick={() => onSelect(key)}
            style={{
              ...styles.option,
              ...(selected ? styles.optionSelected : {}),
            }}
          >
            <Body
              style={{
                ...styles.label,
                ...compactLabel,
                ...(selected ? styles.labelSelected : {}),
              }}
            >
              {label}
            </Body>
          </div>
        );
      })}
    </div>
  );
};
